"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpirationReason = void 0;
var ExpirationReason;
(function (ExpirationReason) {
    ExpirationReason["paymentFailed"] = "payment_failed";
    ExpirationReason["subscriptionCancelled"] = "subscription_cancelled";
    ExpirationReason["priceIncrease"] = "price_increase";
    ExpirationReason["productNotAvailable"] = "product_not_available";
    ExpirationReason["unknownError"] = "unknown_error";
})(ExpirationReason || (exports.ExpirationReason = ExpirationReason = {}));
//# sourceMappingURL=subscription.js.map